import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useEffect, useState } from 'react'

import {Menu} from '../_Menu'
import Header from '../Header';
import Footer from '../_Footer'

// import '../assets/css/emails.css'
import DatePicker from "react-datepicker";
import { EmailsModel } from '../models/EmailsModel';
import { EmailFilterModel, EmailMessage, GetMessageModel, IDNameDescriptionItem } from '../models/superbit-api-models';
import EmailMessageItem from './_EmailMessage';
import MoveToFolderPopup from './_moveToFolderPopup';
import Pagger from '../components/_Pagger';
import CreateFolderPopup from './_createFolder';
import NewEmailMessage from './_NewEmailMessage';
import { IDNameDescriptionItemSelect } from '../components/_IDNameDescriptionItemSelect';
import { IDNameDescriptionDictionary } from '../models/Site';
import PleaseWaitLayer from '../components/_PleaseWaitLayer';
import SetMessageTo_Popup from './_SetMessageTo';
import EmailContentShow from './_EmailShowContent';
import { Dropdown, MenuProps, Select, TreeSelect, message } from 'antd';
import { LeadMessagePopup } from '../leads/_LeadMessagePopup';
import EmailFolder from './_emailFolder';
import CompDatePicker from '../components/compDatePicker/_CompDatePicker';
import { useSelector } from 'react-redux';
import LoginPopup from '../login/_LoginPopUp';
const { TreeNode } = TreeSelect;

const Emails = () => {
    const OpenDateFromRef = React.createRef<DatePicker>();
    const OpenDateToRef = React.createRef<DatePicker>();
    const userLogged = useSelector((state: any) => state.user.value)
    
    // const navigate = useNavigate();
    const emailsModel: EmailsModel = new EmailsModel();
    let mailLoadTimeout: any;

    const [userEmails, setUserEmails] = useState<IDNameDescriptionDictionary>({});
    const [messages, setMessages] = useState<any[]>([]);
    const [loaded, setLoaded] = useState<boolean>(false);
    const [firstLoad, setFirstLoad] = useState<boolean>(true);
    const [loading, setLoading] = useState<boolean>(false)
    const [loadingIcon, setLoadingIcon] = useState<boolean>(false)
    const [openTabs, setOpenTabs] = useState<any[]>([]);
    const [selectedTab, setSelectedtab] = useState<any | null>(null);
    const [selectedMessage, setSellectedMessage] = useState<any>(null);
    const [sellectedMessageId, setSellectedMessageId] = useState<number>(0);
    const [activeMail, setActiveMail] = useState<string>('');
    const [ownerName, setOwnerName] = useState<string>('');
    const [currentMailAccount, setCurrentMailAccount] = useState<any>({});
    const [userSignature, setUserSignature] = useState<string>('');
    // const [user, setUser] = useState<any>({});
    const [mailFolders, setMailFolders] = useState<any>([]);
    const [leadsForRelations, setLeadsForRelations] = useState<any>([]);
    const [userForRelations, setUsersForRelations] = useState<any>([]);
    const [folderName, setFolderName] = useState<string | null>(null);
    const [folderType, setFolderType] = useState<number | null>(null);
    const [mailFilter, setFilter] = useState<EmailFilterModel>();
    const [searchText, setSearchText] = useState<string | null>(null)
    const [messageIdForMoving, setMessageIdForMoving] = useState<number[]>([])
    const [messageIdForSetting, setMessageIdForSetting] = useState<number[]>([])
    const [messageIdForDeletting, setMessageIdForDeletting] = useState<number[]>([])
    const [showCreateNewFolder, setShowCreateNewFolder] = useState<boolean>(false)
    const [promptContent, setPromptContent] = useState<string | null>(null)
    const [promptTitle, setPromptTitle] = useState<string | undefined>('מחיקת הודעה')
    const [popupContent, setPopupContent] = useState<string | null>(null)
    const [popupTitle, setPopupTitle] = useState<string | undefined>(undefined)
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [currentPageChanged, setCurrentPageChanged] = useState<boolean>(false)
    const [treeData, setTreeData] = useState<any[]>([
        {
          value: 'subject',
          title: 'נושא'
        },
        {
          value: 'to',
          title: 'אל'
        },
        {
          value: 'from',
          title: 'מאת'
        },
        {
          value: 'cc',
          title: 'CC'
        },
        {
          value: 'bcc',
          title: 'BCC'
        },
        {
          value: 'body',
          title: 'מייל'
        }
    ]);
    const [selectedOption, setSelectedOption] = useState<string[]>([])
    const [searchInOptions, setSearchInOptions] = useState<string[]>([
        'subject',
        'to',
        'from',
        'cc',
        'bcc',
        'body'
    ]);
    const [selectedReadType, setSelectedReadType] = useState<string>('0');
    const [isAdmin, setIsAdmin] = useState<boolean>(false)
    const [nextUpdate, setNextUpdate] = useState<number>(0)
    const [mailRefreshTime, setMailRefreshTime] =useState<string | null>(null)
    const [allChecked, setAllChecked] = useState<boolean>(false)
    const [timeoutId, setTimeoutId] = useState<number | any | null>(undefined);
    const [refreshTimeOut, setRefreshTimeOut] = useState<any | undefined>(undefined)
    const [showBtnOptions, setShowBtnOptions ] = useState<boolean>(false);

    // Pagger params 
    const [pagerConf, setPagerConf] = useState<any>({
        pageSize: 0,
        currentPage: 1,
        totalItems: 0
    });


    useEffect(()=>{
        init();
    }, [])
    
    useEffect(() => {
        // Clear timeout when the component unmounts or when the timeout changes
        return () => {
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        };
    }, [timeoutId]);
    
    useEffect(() => {
        if (activeMail && activeMail !=='') {
            const filter: EmailFilterModel = mailFilter ? mailFilter : new EmailFilterModel({
                readUnread: 0
            });
            filter.page = 0;
            filter.activeMail = activeMail;
            if (refreshTimeOut) {
                clearTimeout(refreshTimeOut);
            }
            setOpenTabs([]);
            setFilter(filter);
            setFirstLoad(true);
            getFolders();
            getAddresses();
            localStorage.setItem('activeMail', activeMail);
        }
    }, [activeMail])

    useEffect (()=>{
        if (mailFolders && mailFolders.length > 0) {
            if (refreshTimeOut) {
                clearTimeout(refreshTimeOut);
            }
            setFolderName(mailFolders[0].name);
            console.log('setFolderName', mailFolders[0].name)
            if (firstLoad) {
                setFirstLoad(false);
                console.log('load func useEffect mailFolders firstLoad')
                load();
            }
        }
    },[mailFolders])

    useEffect(()=>{
        if (refreshTimeOut) {
            clearTimeout(refreshTimeOut);
        }
        if (mailFilter) {
            let filter: EmailFilterModel = mailFilter;
            let changeMade: boolean = false;
            
            if(folderName && folderName !== '' && filter.folderName !== folderName && !folderType) {
                clearFilterOptions();
                filter = getNewFilter();
                filter.folderName = folderName;
                filter.searchText = '';
                setSearchText('');
                setSelectedOption([]);
                filter.fromDate = undefined;
                filter.toDate = undefined;
                filter.folder = undefined;
                filter.page = 0;
                changeMade = true;
            }
            if (folderType && filter.folder !== folderType) {
                clearFilterOptions();
                filter = getNewFilter();
                filter.folderName = undefined;
                filter.searchText = '';
                setSearchText('');
                setSelectedOption([]);
                filter.fromDate = undefined;
                filter.toDate = undefined;
                filter.folder = folderType;
                filter.page = 0;
                changeMade = true;
            }
            if(currentPageChanged) {
                filter.page = currentPage;
                changeMade = true;
            }

            if (changeMade) {
                setFilter(filter);
                setLoaded(false);
                console.log('load func useEffect on changeMade')
                // load(mailFilter);
            }
        }
    }, [folderName, folderType, currentPageChanged, currentPage])

    useEffect(()=>{
        if (mailFilter) {
            // console.log('Filter', mailFilter)
            if (mailFilter) {
                clearTimeout(refreshTimeOut);
                // setRefreshTimeOut(mailLoadTimeout);
                console.log('load func useEffect mailFilter')
                load();
            }
        }
    }, [mailFilter])

    useEffect(() => {
        if (!loaded) {
            setLoading(true);
            // console.log('load func useEffect loaded')
             load();
        } else {
            setLoading(false);
        }
    },[loaded]);
        
    const init = async() => {
        setLoading(true);
        let loggedUser: any = localStorage.getItem('loggedUser');
        if (loggedUser) {
            loggedUser = JSON.parse(loggedUser);
            setIsAdmin(loggedUser.role == 0);
            console.log('init');
            let emailSettings: any = localStorage.getItem('emailSettings');
            localStorage.setItem('emails_' + (new Date()).getTime(), (new Date()).getTime().toString())
            if (!emailSettings) {
                emailSettings = await emailsModel.getEmailsSettings();
                localStorage.setItem('emailSettings', JSON.stringify(emailSettings));
            } else {
                emailSettings = JSON.parse(emailSettings);
            }
            if (emailSettings && emailSettings.emails.length > 0) {
                configureSettings(emailSettings);
            } else {
                setLoading(false);
                setLoaded(true);
                return;
            }

            const leadsForRelations = await emailsModel.getLeadsForRelations();
            setLeadsForRelations(leadsForRelations);
        }
    }

    const getFolders = async (refresh: boolean = false) => {
        console.log('getFolders');
        setMailFolders([]);
        let folders: any = localStorage.getItem(`emailAccount_${activeMail}`);
        if (refresh || folders == null) {
            folders = await emailsModel.getFolders(activeMail);
            localStorage.setItem(`emailAccount_${activeMail}`, JSON.stringify(folders));
        } else {
            
            if (!folders) {
                console.log('timed outed getFolders')
                setTimeout(() => {
                    getFolders(refresh);
                }, 500);
            } else {
                folders = JSON.parse(folders)
            }
        }
        if (folders && folders.length > 0) {
            const folderTree = [];
            const rootFolders: any[] = folders.filter((f: any) => f.parent == null);
            const children: any[] = folders.filter((f: any) => f.parent !== null)
            rootFolders.forEach((folder: any, index: number) => {
                const subFolders = children.filter((f: any) => f.parent == folder.name);
                // folderTree.push(folder);
                if (subFolders) {
                    folder.folders = subFolders
                }
            })
            console.log('processEmailsRetrieveFolders', rootFolders);
            setMailFolders(rootFolders);
        }
    }

    const getFilter = async() => {
        const filter = mailFilter ? mailFilter : new EmailFilterModel();
        if(folderName) {
            filter.folderName = folderName;
            localStorage.setItem('lastFolderName', folderName)
        } else {
            if (folderType) {
                filter.folder = parseInt(folderType.toString());
                localStorage.setItem('lastFolderName', folderType.toString())
            }
        }
        return filter;
    }

    const getNextTime = () => {
        return new Date((new Date()).getTime() + 60000).getTime();
    }

    const setnextRefresh = async() => {
        // const currentTime = (new Date()).getTime();
        const nextUpdateTime = getNextTime();
        setNextUpdate(nextUpdateTime); 
        clearTimeout(refreshTimeOut);
        mailLoadTimeout = setTimeout(() => {
            console.log('load func timeout mailRefreshTime')
            load(undefined, true);
        }, 60000);
        await setRefreshTimeOut(mailLoadTimeout);
        localStorage.setItem('mailRefreshTime', nextUpdateTime.toString() );
        setMailRefreshTime(nextUpdateTime.toString())
        console.log('mailRefreshTime', mailLoadTimeout);
    }

    const load = async(filter?: any, refresh?: boolean) => {
        const ttt = (new Date()).toTimeString();
        console.log('mailRefreshTime', ttt)
        if (mailFilter) {
            console.log('mailRefreshTime activeMail', refreshTimeOut, mailFilter.activeMail, activeMail);
            
        }
        if (refresh) {
            const savedMailRefreshTime =  localStorage.getItem('mailRefreshTime');
            if (savedMailRefreshTime && savedMailRefreshTime != mailRefreshTime) {
                console.log('mailRefreshTime', ttt, savedMailRefreshTime, mailRefreshTime)
            }
            filter = localStorage.getItem('mailFilter');
            if (filter) {
                filter = JSON.parse(filter)
            }
        } else {
            localStorage.setItem('mailFilter', JSON.stringify(mailFilter))
        }
        const currentTime = (new Date()).getTime().toString();
        console.log('mailRefreshTime', ttt)
        if (!refresh) {
            setLoading(true);
        } else {
            const savedActiveEmail = localStorage.getItem('activeMail');
            if (savedActiveEmail !== activeMail) {
                return;
            }

            // const mailRefreshTime = localStorage.getItem('mailRefreshTime');
            console.log('mailRefreshTime', ttt)
            // console.log('mailRefreshTime', mailRefreshTime)
            
            // if (mailRefreshTime && currentTime < mailRefreshTime) {
            //     console.log('mailRefreshTime cancel')
            //     return;
            // } else {
            //     console.log('mailRefreshTime run')
            // }
        }
        if(!filter) {
            filter = await getFilter();
        }
        const lastFolderName = localStorage.getItem('lastFolderName');
        if (!folderName && !folderType) {
            console.log('mailRefreshTime cancel no folder', ttt, lastFolderName, folderName, folderType)
            return;
        } else {
            console.log('mailRefreshTime run', ttt, filter);
            if (lastFolderName) {
                if (lastFolderName !== folderName) {
                    console.log('mailRefreshTime cancel wrong folder', ttt, lastFolderName, folderName)
                    return;
                }
            }
        }
        setnextRefresh();
        
        console.log('mailRefreshTime update', ttt, localStorage.getItem('mailRefreshTime'))
        
        // if (!refresh) {
        //     setOpenTabs([]);
        // }
        await loadEmails(filter);
        setLoaded(true);
        if(!filter) {
            console.log('mailRefreshTime cancel no filter', ttt)
        }
        if (!refresh) {
            setLoading(false);
        }
    }

    const loadEmails = async(filter?: any) => {
        console.log('loadEmails', filter);
        setLoadingIcon(true);
        if(!filter) {
            filter = mailFilter;
        }
        try {
            const model = await emailsModel.getFilteredlEmails(filter);
            if (model) {
                if (model.messages) {
                    const messages = model.messages;
                    messages.sort((a: any, b: any) => b.date.getTime() - a.date.getTime());
                    messages.forEach((message: any) => {
                        let date = new Date(message.date);
                        const day = date.getDate();
                        let dayString = day.toString();
                        if (day < 10) {
                            dayString = `0${day}`;
                        }
                        const year = date.getFullYear();
                        const month = date.getMonth()+1;
                        let monthStr = month.toString()
                        if (month < 10) {
                            monthStr = `0${month}`;
                        }
                        const dateString = `${dayString}/${monthStr}/${year}`;

                        const hours = date.getHours();
                        const minutes = date.getMinutes();
                        const timeString =`${hours < 10 ? '0' + hours : hours}:${minutes < 10 ? '0' + minutes : minutes}`;

                        message.date = dateString;
                        message.time = timeString;
                        message.isValid = message.id.isValid;
                        message.validity = message.id.validity;
                        message.id = message.id.id;
                        message.checked = false;
                    });
                    await setMessages([]);
                    await setMessages(messages);
                }
                setPagerConf({
                    pageSize: model.pagE_SIZE,
                    currentPage: model.currentPage + 1,
                    totalItems: model.allMailsCounter
                });
                // setTotalEmails(model.allMailsCounter);
                setCurrentPage(model.currentPage);
            }
        } catch (error) {
            
        }
        setLoadingIcon(false);
    }

    const getAddresses = async () => {
        let emailAddresses = localStorage.getItem('emailAddresses');
        if (!emailAddresses) {
            emailAddresses = await emailsModel.emailsGetAddresses(activeMail);
            localStorage.setItem('emailAddresses', JSON.stringify(emailAddresses));
        }
    }

    const configureSettings = (emailSettings: any) => {
        if (emailSettings) {
            if (emailSettings.emails && emailSettings.emails.length > 0) {
                const emailAccounts: IDNameDescriptionDictionary = emailSettings.emails.map((a: any) => {
                    return {
                        description: a.emailAddress,
                        name: a.name,
                        email: a.emailAddress,
                        id: a.id,
                        signature: a.electronicSignature
                    }
                }) as IDNameDescriptionDictionary;
                const mainAccount = emailSettings.emails.find((ea: any) => ea.main == true);
                setUserEmails(emailAccounts);
                let signature: string = '';
                if (mainAccount) {
                    setActiveMail(mainAccount.id);
                    setOwnerName(mainAccount.name);
                    setCurrentMailAccount(mainAccount);
                    // setUserSignature(mainAccount.electronicSignature);
                    signature = mainAccount.electronicSignature
                } else {
                    setActiveMail(emailSettings.emails[0].id);
                    setOwnerName(emailSettings.emails[0].name);
                    setCurrentMailAccount(emailSettings.emails[0]);
                    signature = emailSettings.emails[0].electronicSignature;
                }
                setUserSignature(signature);
                localStorage.setItem('userSignature', signature);
            }
        }
    }

    const openMessage = async (id: number) => {
        let tabContent = openTabs.find((m: any) => m.id == id);
        if (!tabContent) {
            setLoading(true);
            const message = messages.find((m: any) => m.id == id);
            // console.log('selected message', message);
            const oMessage = await getMessageDetails(id);
            if (oMessage && oMessage.uid) {
                console.log('openMessage', oMessage);
                oMessage.star = message.star;
                tabContent = {
                    type: 'showMessage',
                    id: oMessage.uid,
                    title: oMessage.subject,
                    message: oMessage as EmailMessage,
                    ownerName: ownerName,
                    folderName: folderName,
                    folderType: folderType
                }
                openTabs.push(tabContent);
                console.log('openTabs', openTabs);
                const curentMessages = messages;
                const messageIndex = messages.findIndex((m: any) => m.id == id);
                if (messageIndex >= 0) {
                    setMessages([]);
                    curentMessages[messageIndex].read = false;
                    setMessages(curentMessages);
                }
                setOpenTabs(openTabs);
            } else {

            }
            setLoading(false); 
        }
        if (tabContent) {
            showMessage(tabContent);
            console.group('openMessage', tabContent)
        } else {
            showEmails();
        }
        console.log('openTabs', openTabs)
    }

    const closeMessage = (id: number, e?: Event) => {
        if (e) {
            e.preventDefault();
        }
        const openEmails = openTabs.filter((m: any) => m.id !== id);
        console.log('openTabs', openEmails);
        setOpenTabs(openEmails);
        showEmails();
    }

    const getMessageDetails = async(uid: number) => {
        const request: any = {
            uid: uid,
            activeMail: activeMail
        }
        if (mailFilter) {
            // if (!mailFilter.searchText) {
                if (mailFilter.folder) {
                    request.type = mailFilter.folder;
                }
                if (mailFilter.folderName) {
                    request.folderName = mailFilter.folderName;
                }
            // }
        }
        const oMessage = await emailsModel.getMessage(request);
        if (oMessage) {
            if (oMessage.statusCode) {
                setPopupContent(oMessage.statusMessage);
            } else {
                let date = new Date(oMessage.date);
                const dateString = date.toLocaleDateString();
                oMessage.dateString = dateString;
                showMessage(oMessage);
            }
        }
        return oMessage;
    }

    const showEmails = () => {
        setSellectedMessage(null);
        setSelectedtab(null);
        setSellectedMessageId(0);
    }
    
    const showMessage = async(oMessage: any)  => {
        await setSellectedMessageId(0);
        await setSelectedtab(null);
        await setSellectedMessage(null);
        console.log('openMessage', oMessage);
        oMessage.read = true;
        await setSellectedMessage(oMessage);
        await setSellectedMessageId(oMessage.id);
    }

    const startNewEmail = ()=>{
        setSellectedMessageId(0);
        setSelectedtab(null);
        setSellectedMessage(null);
        const messageId: number = (new Date()).getTime();
        const message = {
            body: '',
            to: '',
            cc: '',
            title: '',
            bcc: '',
            id: messageId,
            attachments: []
        }
        const tabContent = {
            type: 'newMessage',
            id: messageId,
            title: 'הודעה חדשה',
            message,
        }
        openTabs.push(tabContent);
        setOpenTabs(openTabs);
        setSellectedMessageId(messageId);
        setSellectedMessage(tabContent);
    }

    const updateTabData = (tabId: string, tabData: any) => {
        console.log('tabData', tabData);
        let tabIndex = openTabs.findIndex((m: any) => m.id == tabId);
        const message = {
            body: tabData.body,
            to: tabData.to,
            cc: tabData.cc,
            title: tabData.title,
            bcc: tabData.bcc,
            attachments: tabData.attachments
        };
        openTabs[tabIndex] = {
            type: 'newMessage',
            id: tabId,
            title: 'הודעה חדשה: ' + tabData.title,
            message,
        }
        setOpenTabs(openTabs);
        console.log(openTabs);
    }

    const selectFolder = async(folder: any) => {
        // await clearFilter();
        clearFilterOptions();
        // const filter: EmailFilterModel = getNewFilter();
        // setFilter(filter);
        await setFolderName(folder.name);
        if (folder.type !== null) {
            setFolderType(folder.type);
        } else {
            setFolderType(null);
        }
    }

    const onTreeSelectChange = async (value: string[], l:any, e: any) => {
        const filter: any = mailFilter;
        setSelectedOption(value)
        if (value && value.length>0) {
            filter.SearchOption = value;
        } else {
            filter.SearchOption = undefined;
        }
        await setFilter(filter);
        if (filter.searchText && filter.searchText.length > 0) {
            console.log('load func onTreeSelectChange')
            load(filter);
        }
    }

    const handleSearchChange =  async (event:any) => {
        const searchText = event.target.value;
        console.log('handleSearchChange', timeoutId, searchText, event)
        let filter: any= {};
        if (mailFilter) {
            filter = mailFilter;
        }
        filter.searchText = searchText;
        await setSearchText(searchText)
        if (timeoutId) {
            clearTimeout(timeoutId);
        }
        const newTimeoutId = setTimeout(() => {
            console.log('handleSearchChange', timeoutId, searchText)
            console.log('load func handleSearchChange')
            load(filter)
        }, 1000)
        setTimeoutId(newTimeoutId);
    };

    const onActiveEmailChange = async(name:string, value:any) => {
        console.log(name, value);
        if (refreshTimeOut) {
            clearTimeout(refreshTimeOut);
        }
        const emailAccounts: any[] = [];
        Object.keys(userEmails).forEach((key: string)=>{
            emailAccounts.push(userEmails[key])
        })
        const selectedAccount = emailAccounts.find((ea: any) => ea.id == value);
        console.log('emailAccounts', emailAccounts, selectedAccount)
        setActiveMail(selectedAccount.id);
        setOwnerName(selectedAccount.name);
        
    }

    const setFromDate = async (d: Date) => {        
        if (mailFilter) {
            if (refreshTimeOut) {
                clearTimeout(refreshTimeOut);
            }
            const filter: EmailFilterModel = mailFilter;
            filter.fromDate = d;
            filter.page=0;
            await setFilter(filter);
            console.log('load func setFromDate')
            load(filter)
        }
    }

    const setToDate = async (d: Date) => {        
        if (mailFilter) {
            if (refreshTimeOut) {
                clearTimeout(refreshTimeOut);
            }
            const filter: EmailFilterModel = mailFilter;
            filter.toDate = d;
            filter.page=0;
            await setFilter(filter);
            console.log('load func setToDate')
            load(filter)
        }
    }

    const onMessageTypeChange = (newValue: string) => {
        if (mailFilter) {
            const filter: EmailFilterModel = mailFilter;
            filter.readUnread = parseInt(newValue);
            setSelectedReadType(newValue);
            setFilter(filter);
            // setLoaded(false);
            console.log('load func onMessageTypeChange')
            load(filter)
        }
    }

    const getNewFilter = () => {
        const filter: EmailFilterModel = new EmailFilterModel({
            readUnread: undefined,
            activeMail,
            searchText:'',
            fromDate: undefined,
            toDate: undefined
        });
        if (folderType) {
            filter.folder = parseInt(folderType.toString());
        } else {
            if (folderName) {
                filter.folderName = folderName;
            }
        }

        return filter
    }

    const clearFilterOptions = () => {
        setSelectedOption([])
        setSelectedReadType('0');
        setSearchText('');
    }

    const clearFilter = async () => {
        clearFilterOptions();
        const filter: EmailFilterModel = getNewFilter();
        setFilter(filter);
    }

    const onMoveMessageClick = (messageUid: number) => {
        setMessageIdForMoving([messageUid])
    }

    const onSetMessageClick = (messageUid: number) => {
        setMessageIdForSetting([messageUid])
    }

    const onStarClick = async(messageUid: number) => {
        const requestBody: any = {
            "Uid": messageUid,
            "activeMail": activeMail
        };
        if (folderName && folderName != '') {
            requestBody.folderName = folderName
        } else {
            if (folderType && folderType >= 0) {
                requestBody.Type = folderType
            }
        }
        const res = await emailsModel.emailsAddRemoveStar(requestBody);
        const messageIndex = messages.findIndex((m: any) => m.id == messageUid);
        messages[messageIndex].star = !messages[messageIndex].star;
        setMessages([]);
        setMessages(messages);
        console.log('onStarClick', messageUid, res);
    }

    const toggleMessageReadMode = async(messageUid: number) => {
        const requestBody: any = {
            "Uid": messageUid,
            "activeMail": activeMail
        };
        if (folderName && folderName != '') {
            requestBody.folderName = folderName
        } else {
            if (folderType && folderType >= 0) {
                requestBody.Type = folderType
            }
        }
        // console.log('toggleMessageReadMode', messageUid);
        const res = await emailsModel.emailsToggleReadMode(requestBody);
        if (res && res.statusCode != -1) {
            const messageIndex = messages.findIndex((m: any) => m.id == messageUid);
            messages[messageIndex].read = !messages[messageIndex].read;
            await setMessages([]);
            await setMessages(messages);
            console.log('onReadClick', messageUid, res);
        } else {
            setPopupContent('אירעה שגיאה');
            setPopupTitle('');
        }
    }

    const onMessageCheck = async(messageUid: number) => {
        const messageIndex = messages.findIndex((m: any) => m.id == messageUid);
        messages[messageIndex].checked = !messages[messageIndex].checked;
        console.log('onMessageCheck', messages[messageIndex].checked);
        setnextRefresh();
        setMessages([]);
        setMessages(messages);
    }

    const getAllCheckedMessages = () => {
        const checkedMessages = messages.filter((m: any) => m.checked == true)
        const ids: number[] = [];
        checkedMessages.forEach((m: any) => {
            ids.push(m.id)
        });
        return ids;
    }

    const onDeleteAllChecked = async () => {
        const checked = getAllCheckedMessages();
        if (checked && checked.length > 0) {
            openDletePromptPopUp(checked);
        }
        setShowBtnOptions(false);
        console.log('onDeleteAllChecked', checked)
    }

    const onSendAllCheckedToFolder = async () => {
        const checked = getAllCheckedMessages();
        console.log('onSendAllCheckedToFolder', checked)
        setMessageIdForMoving(checked);
    }


    const toggleAllCheck = async() => {
        setnextRefresh();
        const checked: boolean = !allChecked
        messages.map((m: any) => {
            m.checked = checked;
        });
        await setMessages([]);
        await setMessages(messages);
        await setAllChecked(checked)
        
        console.log('toggleAllCheck', checked)
    }
    
    const onSetAllChecked = async () => {
        const checked = getAllCheckedMessages();
        console.log('onDeleteAllChecked', checked);
        setMessageIdForSetting(checked)
    }
    
    const items: MenuProps['items'] = isAdmin ? [
        {
            key: '1',
            label: (
                <li className="pointer rtl"
                    onClick={onSetAllChecked}
                >
                    שייך ל
                </li>
            ),
        },
        {
            label: 
                <li className="pointer rtl"
                    onClick={onSendAllCheckedToFolder}
                >
                    העבר לתקיה
                </li>,
            key: '2',
        },
        {
            label: 
                <li className="pointer rtl"
                    onClick={onDeleteAllChecked}
                >
                    מחק
                </li>,
            key: '3'
        }
    ] : [
        {
            key: '1',
            label: (
                <li className="pointer rtl"
                    onClick={onSetAllChecked}
                >
                    שייך ל
                </li>
            ),
        },
        {
            label: 
                <li className="pointer rtl"
                    onClick={onSendAllCheckedToFolder}
                >
                    העבר לתקיה
                </li>,
            key: '2',
        }
    ];

    const openPromptPopUp = (mid: number) => {
        setPromptContent('האם את/אתה בטוח/ה?');
        setMessageIdForDeletting([mid]);
    }

    const openDletePromptPopUp = (mids: number[]) => {
        setPromptContent('האם את/אתה בטוח/ה?');
        setMessageIdForDeletting(mids);
    }
    
    const onPromptApprove = (mid: number) => {
        onDeleteMessage(messageIdForDeletting)
        setPromptContent(null);
        setMessageIdForDeletting([]);
        console.log('onDeleteMessage', messageIdForDeletting);
    }

    const closePromptPopup = () => {
        setPromptContent(null);
    }

    const closePopup = () => {
        setPopupContent(null);
    }

    const onDeleteMessage = async (messageUids: number[]) => {
        const requestBody: any = {
            "Uids": messageUids,
            "activeMail": activeMail
        };
        if (folderName && folderName != '') {
            requestBody.folderName = folderName
        } else {
            if (folderType && folderType >= 0) {
                requestBody.Type = folderType
            }
        }
        const res = await emailsModel.emailsRemoveMessage(requestBody).then((res: any) =>{
            console.log('load func emailsRemoveMessage')
            load(mailFilter);
        });
        console.log('onDeleteMessage', messageUids, res);
    }

    const moveMessageToFolder = async (messageIds: number[],targetFolderName: string) => {
        console.log('moveMessageToFolder', messageIds, 'To:', folderName);
        const res = await emailsModel.moveEmailToFolder(folderName, folderType, targetFolderName, messageIds, activeMail);
        if (res && res.statusCode==200) {
            setPopupContent('העברה לתיקיה הסתיימה בהצלחה');
            setPopupTitle('');
            load(mailFilter);
        } else {
            setPopupTitle('');
            setPopupContent(' העברה לתיקיה נכשלה');
        }
        closeMoveToFolderPopup();
    }

    const openPopup = (data: any) => {
        setPopupTitle(data.title)
        setPopupContent(data.description);
    }
    
    const setMessageToTarget = async (messageIds: number[], type: string, leadId: string) => {
        const request = {
            "GetMessageModel":{
                "Uids": messageIds, 
                "Type": folderType,
                "FolderName": folderName
            },
            "LeadId": leadId,
            "ActiveMail": activeMail
        };
        const res = await emailsModel.emailsSaveMessageAsTreatment(request);
        if (res && res.statusCode==200) {
            setPopupContent('פעולת שיוך הסתיימה בהצלחה');
        } else {
            setPopupContent('פעולת שיוך נכשלה');
        }
        closeSettingToPopup();
    }

    const closeMoveToFolderPopup = () => {
        setMessageIdForMoving([])
    }
    
    const closeSettingToPopup = () => {
        setMessageIdForSetting([])
    }

    const closeCreateFolderPopup = () => {
        setShowCreateNewFolder(false);
    }

    const sendMail = async(formData: any, tabId?: number) => {
        setLoading(true);
        const res = await emailsModel.emailsSendMessage(formData);
        if (res &&  res.label == 'OK') {
            setPopupTitle('שליחת מייל')
            setPopupContent('הודעה נשלחה בהצלחה');
        } else {
            setPopupTitle('שליחת מייל')
            setPopupContent('שליחת הודעה נכשלה');
        }
        if (tabId) {
            console.log('selectedTab', tabId);
            closeMessage(tabId)
        }
        setLoading(false);
        showEmails();
        return res;
    }

    const onChangePage= (newPage: number) => {
        console.log('onChangePage', newPage);
        setCurrentPage(newPage);
        setCurrentPageChanged(true);

        if (mailFilter) {
            const filter = mailFilter;
            filter.page = newPage
            load(filter);
        }
    }

    const onPageRefresh = () => {
        console.log('load func onPageRefresh')
        load(mailFilter);
    }

    const onCreateFolderClick = (e: any) => {
        setShowCreateNewFolder(true);
    }

    const createFolder = async (folderName: string) => {
        console.log(folderName);
        const createFolderRes = await emailsModel.emailsCreateNewFolder(folderName, activeMail);
        if (createFolderRes && createFolderRes.statusCode == 200) {
            setPopupTitle('יצירת תיקיה')
            setPopupContent('יצירת תיקיה הסתיימה בהצלחה');
        } else {
            setPopupTitle('יצירת תיקיה')
            setPopupContent('יצירת תיקיה הסתיימה בכישלון');
        }
        setShowCreateNewFolder(false);
        getFolders(true);
    }
    
    const onOptionsBtnClick = () => {
        if (showBtnOptions) {
            setShowBtnOptions(false);
        } else {
            setShowBtnOptions(true);
        }
    }
    
    const onOptionItemClick = (key: number) => {
        message.info(`Click on item ${key}`);
    };

    // const generateGuid = () => {
    //     let guid = '';
    //     for (let i=0; i<4; i++) {
    //         if (guid !='') {
    //             guid += '-';
    //         }
    //         const randomNum = Math.floor(Math.random() * 1000000);
    //         guid += `${randomNum}`;
    //     }
        
    //     return guid;
    // }

    return (
        <>
            <div className="main-content rtl">
                {
                    messageIdForMoving.length > 0  && (
                        <MoveToFolderPopup
                            closePopup={closeMoveToFolderPopup}
                            moveToFolder={moveMessageToFolder}
                            messageId={messageIdForMoving}
                            mailFolders={mailFolders}></MoveToFolderPopup>
                    )
                }
                {
                    messageIdForSetting.length > 0  && (
                        <SetMessageTo_Popup
                            closePopup={closeSettingToPopup}
                            setToSelectedTarget={setMessageToTarget}
                            leadsForRelations={leadsForRelations}
                            userForRelations={userForRelations}
                            messageId={messageIdForSetting}></SetMessageTo_Popup>
                    )
                }
                {
                    showCreateNewFolder  && (
                        <CreateFolderPopup
                            closePopup={closeCreateFolderPopup}
                            createFolder={createFolder}
                            mailFolders={mailFolders}></CreateFolderPopup>
                    )
                }
                {
                    promptContent!=null && promptContent!=''?
                        (
                        <LeadMessagePopup
                        ClosePopup={()=>closePromptPopup()}
                        OnApprove={(mid: number)=>onPromptApprove(mid)}
                        approveBtnTitle={'מחק'}
                        messageContent={promptContent}
                        messageTitle={promptTitle}
                        />
                        ):""
                }
                {
                    popupContent!=null && popupContent!='' ?
                        (
                        <LeadMessagePopup
                        ClosePopup={()=>closePopup()}
                        approveBtnTitle={'מחק'}
                        messageContent={popupContent}
                        messageTitle={popupTitle}
                        />
                        ):""
                }
                {
                    loading && (
                        <PleaseWaitLayer />
                    )
                }
                {
                    !userLogged && <LoginPopup />
                }
                <Menu activePage='Email' />
                <div className="center-content">
                    <Header PageName="מיילים" />
                    <section className="page-tab-row">
                        <div className="emails-tab-row-container">
                            <div className="emails-tab-row">
                                <div className={`email-tab email-tab-clients ${sellectedMessageId == 0 ? 'selected' : ''}`} onClick={showEmails}>
                                    <div className="top-border"></div>
                                    <div className="tab-content">
                                        <div className="label">
                                            תיבת מייל
                                        </div>
                                        <div className="icon-holder pointer">
                                            <div className="icon x-close-grey"></div>
                                        </div>
                                        {loadingIcon ? (
                                        <div className='icon loading'></div>
                                        ):(<></>)}
                                    </div>
                                </div>
                                {openTabs.map((m:any) => {
                                    return (
                                        <div className={`email-tab email-tab-view-message email-tab-${m.id} ${sellectedMessageId == m.id ? 'selected' : ''}`} key={m.id}>
                                            <div className="top-border"></div>
                                            <div className="tab-content">
                                                <div className="label" onClick={(e:any)=>{openMessage(m.id)}}>
                                                    {m.title}
                                                </div>
                                                <div className="icon-holder pointer">
                                                    <div className="icon x-close-grey" onClick={(e:any) => closeMessage(m.id, e)}></div>
                                                </div>
                                            </div>
                                        </div>
                                    )
                                })}
                                <div className={`email-tab new-email-tab  ${sellectedMessageId < 0 ? 'selected' : 'hidden'}`}>
                                    <div className="top-border"></div>
                                    <div className="tab-content">
                                        <div className="label">
                                            הודעה חדשה
                                        </div>
                                        <div className="icon-holder pointer">
                                            <div className="icon x-close-grey" onClick={showEmails}></div>
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </section>
                    <section className={`page-tab-content all-emails ${sellectedMessageId == 0 ? 'selected' : ''}`} id="all-emails">
                        <section className="main-body only-emails flex-centered flex-space-between">
                            <div className="emails-content-column emails-list emails-right-column">
                                <div>
                                {userEmails ? (
                                    <IDNameDescriptionItemSelect
                                        OnChange={onActiveEmailChange}
                                        Id={"EmailAccount"}
                                        Value={activeMail}
                                        Options={userEmails}
                                        style={{width: '100%'}}
                                    />
                                    ) : ""
                                }
                                </div>
                                <button type="button" id="btn-new-email" className="new-email button blue flex-centered flex-justify-center" onClick={startNewEmail}>
                                    אימייל חדש
                                </button>
                                <div className="emails-menu email-content-block mail-content-scrollbar">
                                    {mailFolders && mailFolders.map((folder: any, index: number) =>
                                        {
                                            return (
                                                <EmailFolder onSelect={selectFolder} currentFolder={folderName} folder={folder} index={index}></EmailFolder>
                                            )})
                                        }
                                    <div className="emails-menu-item new-folder-item">
                                        <div className="label pointer" onClick={(e: any) => onCreateFolderClick(e)}>
                                            + תקיה חדשה
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="emails-content-column content-body emails-list emails-list-view">
                                <div className="filter-row">
                                    <div className="filter-input auto-width">
                                        <TreeSelect
                                            treeLine
                                            placeholder='all'
                                            showSearch
                                            style={{
                                                width: '100%',
                                            }}
                                            dropdownStyle={{
                                            maxHeight: 400,
                                                overflow: 'auto',
                                            }}
                                            allowClear
                                            onChange={(v: string[], l:any, e: any)=> onTreeSelectChange (v, l, e)}
                                            treeData={treeData}
                                            treeCheckable
                                            value={selectedOption}
                                        />
                                    </div>
                                    <div className="filter-input search">
                                        <input type="text" placeholder="חיפוש" value={searchText ? searchText : ''} onChange={handleSearchChange} />
                                        <div className="icon search"></div>
                                    </div>
                                    <div className="filter-input">
                                        <CompDatePicker value={mailFilter && mailFilter.fromDate ? mailFilter.fromDate : null} onChange={(date: Date) => setFromDate(date)} /> 
                                        {/* <DatePicker
                                                ref={OpenDateFromRef}
                                                selected={mailFilter && mailFilter.fromDate ? mailFilter.fromDate : null}
                                                onChange={setFromDate}
                                                dateFormat='dd/MM/yyyy'
                                        />
                                        <div className="icon calendar"></div> */}
                                    </div>
                                    <div className="filter-input">
                                        <CompDatePicker value={mailFilter && mailFilter.toDate ? mailFilter.toDate : null} onChange={(date: Date) => setToDate(date)} /> 
                                        {/* <DatePicker
                                                ref={OpenDateToRef}
                                                selected={mailFilter && mailFilter.toDate ? mailFilter.toDate : null}
                                                onChange={setToDate}
                                                dateFormat='dd/MM/yyyy'
                                        />
                                        <div className="icon calendar"></div> */}
                                    </div>
                                    <div className="filter-input select">
                                        
                                        <Select
                                            style={{ width: '100%' }}
                                            placeholder="נא לבחור מיגון"
                                            defaultValue={selectedReadType}
                                            value={selectedReadType}
                                            onChange={onMessageTypeChange}
                                            options={
                                                [
                                                    {
                                                        label: 'הכל',
                                                        value: '0'
                                                    },
                                                    {
                                                        label: 'לא קראתי',
                                                        value: '1'
                                                    },
                                                    {
                                                        label: 'קראתי',
                                                        value: '2'
                                                    },
                                                    {
                                                        label: 'לא נענו',
                                                        value: '3'
                                                    }
                                                ]
                                            }
                                        />
                                    </div>
                                    <div className="filter-button">
                                        <div className="icon refresh-counter pointer" onClick={clearFilter}></div>
                                    </div>
                                </div>
                                <div className="action-row">
                                    <div className="inner-cell">
                                        <div className="checkbox">
                                            <input type="checkbox" className="check-all-emails" id="check-all-emails" onClick={toggleAllCheck} />
                                        </div>
                                        <div className='cell rtl'>
                                            <Dropdown menu={{ items }}>
                                                <button className="act-btn">
                                                    פעולות
                                                </button>
                                            </Dropdown>
                                            {/* <button className="act-btn" onClick={onOptionsBtnClick}>
                                                פעולות
                                            </button>
                                            {showBtnOptions && (<ul className="btn-menu">
                                                <li className="pointer"
                                                    onClick={onSetAllChecked}
                                                >
                                                    שייך ל
                                                </li>
                                                <li className="pointer"
                                                    onClick={onSendAllCheckedToFolder}
                                                >
                                                    העבר לתקיה
                                                </li>
                                                {
                                                    isAdmin ? (<>
                                                        <li className="pointer"
                                                            onClick={onDeleteAllChecked}
                                                        >
                                                            מחק
                                                        </li>
                                                    </>) : (<></>)
                                                }
                                            </ul>)} */}
                                        </div>
                                    </div>
                                    <div className="inner-cell">
                                        <div className="icon gear"></div>
                                    </div>
                                </div>
                                <div className='email-content-block mail-content-scrollbar'>
                                    {messages && messages.length>0 ?messages.map((message: any, i: number)=>{
                                        return (
                                            <EmailMessageItem
                                                message={message}
                                                openMessage={openMessage}
                                                onMoveMessageClick={onMoveMessageClick}
                                                onSetMessageClick={onSetMessageClick}
                                                onDeleteMessage ={isAdmin ? openPromptPopUp : ()=>{}}
                                                onStarClick={onStarClick}
                                                onMessageCheck={onMessageCheck}
                                                isAdmin={isAdmin}
                                                key={message.id}
                                                actions={
                                                    [
                                                        {
                                                            action: 'toggleReadMode',
                                                            callback: toggleMessageReadMode
                                                        }
                                                    ]
                                                } />
                                        )}
                                    ) : ""}
                                    
                                </div>
                            </div>
                        </section>
                        
                        <footer className="footer emails-list-footer emails-list-view">
                            <Pagger pagerConf={pagerConf} changePage={onChangePage} refresh={onPageRefresh}></Pagger>
                        </footer>
                    </section>
                    { selectedMessage && sellectedMessageId > 0 && <>
                        {
                            selectedMessage.type == 'showMessage' ? (
                    <section className={`page-tab-content email-content ${sellectedMessageId > 0 ? 'selected' : ''}`} id={`email-content ${selectedMessage.id}`}>
                        <EmailContentShow
                            activeMail={activeMail}
                            uId={sellectedMessageId}
                            message={selectedMessage.message}
                            sendMail={sendMail}
                            onStarClick={onStarClick}
                            onMoveMessageClick={onMoveMessageClick}
                            onSetMessageClick={onSetMessageClick}
                            isAdmin={isAdmin}
                            onDeleteMessage ={isAdmin ? openPromptPopUp : ()=>{}}
                            openPopup={openPopup}
                            mainAccount={currentMailAccount}
                            folderName={selectedMessage.folderName}
                            folderType={selectedMessage.folderType}
                        ></EmailContentShow>
                    </section>
                            ) :
                            (
                    <section className={`page-tab-content new-email-content ${sellectedMessageId > 0 ? 'selected' : ''}`} id={`new-email-content ${selectedMessage.id}`}>
                        <NewEmailMessage 
                            activeMail={activeMail}
                            signature={userSignature}
                            sendMail={sendMail}
                            openPopup={openPopup}
                            subject={selectedMessage.message.title}
                            body={selectedMessage.message.body}
                            attachments={selectedMessage.message.attachments}
                            cc={selectedMessage.message.cc}
                            to={selectedMessage.message.to}
                            bcc={selectedMessage.message.bcc}
                            tabId={selectedMessage.id}
                            updateTabData={updateTabData}
                        />
                    </section>
                            )
                        }
                    </>
                            
                    }
                    
                </div>
            </div>
        </>
      )
}

export default Emails;